import { render, staticRenderFns } from "./AddContactModal.html?vue&type=template&id=2bfcad00&scoped=true&"
import script from "./AddContactModal.vue?vue&type=script&lang=js&"
export * from "./AddContactModal.vue?vue&type=script&lang=js&"
import style0 from "./AddContactModal.scss?vue&type=style&index=0&id=2bfcad00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcad00",
  null
  
)

export default component.exports